export const REACT_APP_NODE_ENV =  process.env.REACT_APP_NODE_ENV;

export const OKTA_CLIENT = process.env.REACT_APP_OKTA_CLIENT;
export const OKTA_SECRET = process.env.REACT_APP_OKTA_SECRET;

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const MARKETO_FOLDER = process.env.MARKETO_FOLDER !== undefined ? parseInt(process.env.MARKETO_FOLDER) : 23538;